import React, { useContext, useEffect, useState } from "react";
import Restriction from "../../settings/Restriction";
import { useDispatch, useSelector } from "react-redux";
import { getRestrictionData } from "../../../redux/requests/settings";
import SaveButton from "./SaveButton";
import { ContextAll } from "../../saveFile/saveFile";
import { getFileFromUrl } from "../../../hooks/helpers";

const AdminRestriction = () => {
  const language = useSelector((state) => state.changeLang.language);
  const dispatch = useDispatch();
  const { setSettingsFile } = useContext(ContextAll);

  const [id, setId] = useState(null);

  useEffect(() => {
    const getData = async () => {
      const data = document.querySelector("#settings")?.dataset;
      if (!data) return;

      const { id: folderId, linkEntryId, fileEntryId } = data;
      const restrictionParams = folderId
        ? { folderId }
        : { linkEntryId, fileEntryId };

      setId(folderId ?? null);
      const { payload } = await dispatch(getRestrictionData(restrictionParams));

      if (payload.scheduleAssess?.file) {
        const file = await getFileFromUrl(payload.scheduleAssess.file, "file");
        setSettingsFile([file]);
      }
    };

    getData();
  }, [dispatch]);

  if (!language) {
    return null;
  }

  return (
    <>
      <Restriction />
      <SaveButton id={id} />
    </>
  );
};

export default AdminRestriction;
